// Analytics Context Actions
export const ANALYTICS_ACTIONS = {
  UPDATE_CONTEXT: 'ANALYTICS_UPDATE_CONTEXT',
  RESET_CONTEXT: 'ANALYTICS_RESET_CONTEXT',
};

// Action creators
export const updateAnalyticsContext = (data: any) => ({
  type: ANALYTICS_ACTIONS.UPDATE_CONTEXT,
  payload: data,
});

export const resetAnalyticsContext = () => ({
  type: ANALYTICS_ACTIONS.RESET_CONTEXT,
}); 